export const LEVELS = [
  {
    label: "KINDERGARTEN",
    value: "KINDERGARTEN",
    id: 1
  },
  {
    label: "1ST GRADE",
    value: "1ST GRADE",
    id: 2
  },
  {
    label: "STARTER",
    value: "STARTER",
    id: 3
  },
  {
    label: "JUNIOR",
    value: "JUNIOR",
    id: 4
  },
  {
    label: "PRE-INTERMEDIATE KIDS",
    value: "PRE-INTERMEDIATE KIDS",
    id: 5
  },
  {
    label: "INTERMEDIATE SPOKEN ENGLISH",
    value: "INTERMEDIATE SPOKEN ENGLISH",
    id: 6
  },
  {
    label: "UPPER INTERMEDIATE",
    value: "UPPER INTERMEDIATE",
    id: 7
  },
  {
    label: "ADVANCED",
    value: "ADVANCED",
    id: 8
  },
  {
    label: "PRE-STARTER",
    value: "PRE-STARTER",
    id: 10
  },
  {
    label: "PREPARATORY",
    value: "PREPARATORY",
    id: 11
  },
  {
    label: "PRIMARY",
    value: "PRIMARY",
    id: 12
  },
  {
    label: "ELEMENTARY",
    value: "ELEMENTARY",
    id: 13
  },
  {
    label: "INTERMIDATE",
    value: "INTERMIDATE",
    id: 14
  },
  {
    label: "UPPER INTERMEDIATE",
    value: "UPPER INTERMEDIATE",
    id: 15
  },
]